import { Label, Select, SelectContent, SelectItem, SelectTrigger, SelectValue, Stack } from '@careflux/primitives';
import type { FilterSelectProps } from './components.types';

const ALL_VALUE = '__all__';

export const FilterSelect = ({ id, label, allLabel, value, options, disabled, onChange }: FilterSelectProps) => (
  <Stack gap="xs">
    <Label htmlFor={id}>{label}</Label>
    <Select
      value={value ?? ALL_VALUE}
      onValueChange={(next) => onChange(next === ALL_VALUE ? null : next)}
      disabled={disabled}
    >
      <SelectTrigger id={id} aria-label={label}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={ALL_VALUE}>{allLabel}</SelectItem>
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  </Stack>
);
